import { render, staticRenderFns } from "./NormalSearchNav84.vue?vue&type=template&id=b28037b4&scoped=true"
import script from "./NormalSearchNav84.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav84.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28037b4",
  null
  
)

export default component.exports